export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-background-50 rounded-3xl p-8 md:p-12 border border-background-200/60">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">随时随地，畅享阅读</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              妖精漫画网完美适配手机、平板和电脑，下拉式阅读体验在各种设备上都流畅顺滑。无需下载安装，打开浏览器即可进入韩漫日漫国漫的精彩世界。等车、午休、睡前——碎片时间也能追更热漫。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full text-sm transition-all whitespace-nowrap"
              >
                <i className="ri-smartphone-line mr-2"></i>手机端阅读
              </a>
              <a
                href="#cards"
                className="px-8 py-3 border-2 border-background-300 hover:border-primary-400 text-foreground-700 font-medium rounded-full text-sm transition-all whitespace-nowrap"
              >
                <i className="ri-compasses-line mr-2"></i>浏览漫画
              </a>
            </div>
          </div>
          <div className="flex-shrink-0 w-full max-w-[360px]">
            <div className="relative">
              <div className="absolute -inset-3 bg-gradient-to-br from-primary-200/30 via-accent-200/20 to-primary-100/30 rounded-[2.5rem] blur-xl"></div>
              <div className="relative rounded-[2rem] overflow-hidden border-4 border-background-300 bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20displaying%20a%20beautiful%20colorful%20manga%20webtoon%20page%20with%20vertical%20scrolling%20layout%2C%20warm%20lighting%2C%20Korean%20manhwa%20style%20art%2C%20romance%20and%20fantasy%20themes%2C%20clean%20modern%20phone%20mockup%2C%20cozy%20reading%20environment&width=600&height=900&seq=app-mobile-manga&orientation=portrait"
                  alt="妖精漫画网手机端阅读体验 - 随时随地畅享韩漫日漫国漫"
                  className="w-full h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}